import React, { PropTypes } from 'react';
import {
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import RaisedButton from 'material-ui/RaisedButton';

const styles = {
  name: {
    textField: {
      // width: 110,
    },
  },
  radioButtonGroup: {
    display: 'inline-flex',
  },
  radioButton: {
    width: 100,
  },
};

const CounterListRow = ({ counter, rowStyles, onChange, onDelete }) => {
  const wrapOnChange = (fnc, field, event, value) => {
    fnc(field, value);
  };

  const wrapSelecFieldtOnChange = (fnc, field, event, index, value) => {
    fnc(field, value);
  };

  return (
    <TableRow>
      <TableRowColumn style={rowStyles.column.name}>
        <TextField
          style={styles.name.textField}
          name="name"
          value={counter.name}
          onChange={wrapOnChange.bind(this, onChange, 'name')}
          type="text"
          fullWidth={true}
        />
      </TableRowColumn>

      <TableRowColumn style={rowStyles.column.status}>
        <RadioButtonGroup
          name="status"
          defaultSelected="active"
          valueSelected={counter.status}
          style={styles.radioButtonGroup}
          onChange={wrapOnChange.bind(this, onChange, 'status')}>
          <RadioButton
            value="active"
            label="啟用"
            style={styles.radioButton}
          />
          <RadioButton
            value="inactive"
            label="停用"
            style={styles.radioButton}
          />
        </RadioButtonGroup>
      </TableRowColumn>

      <TableRowColumn style={rowStyles.column.order}>
        <TextField
          name="order"
          value={counter.order}
          onChange={wrapOnChange.bind(this, onChange, 'order')}
          pattern="^[0-9]"
          type="text" />
      </TableRowColumn>

      <TableRowColumn style={rowStyles.column.button}>
        <RaisedButton
          label="刪除"
          secondary={true}
          onClick={onDelete} />
      </TableRowColumn>
    </TableRow>
  );
};

CounterListRow.propTypes = {
  counter: PropTypes.object.isRequired,
  rowStyles: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CounterListRow;



// WEBPACK FOOTER //
// client/adminPanel/panel/counters/CounterListRow.js